/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import React from "react"

export default function ToastError({ message, handlePictoClick }) {
  return (
    <span>
      {message}
      <i
        className="fa fa-window-close d-flex justify-content-end"
        aria-hidden="true"
        onClick={handlePictoClick}
        data-cy="toastValidatorError"
      />
    </span>
  )
}
